import MatchEntriesBox from 'modules/BulkSelect/components/MatchEntriesBox/MatchEntriesBox';

const getBulkIdentifierMatchFilter = () => ({
  key: 'bulkMatch',
  source: 'bulkMatch',
  searchable: false,
  selector: 'name',
  label: 'bulkMatch',
  isEnabled: true,
  filterName: 'Names, emails, or ids',
  ComponentClass: MatchEntriesBox,
});

export default getBulkIdentifierMatchFilter;
